/** 拨号状态 **/
<template>
  <div class="home data-panel-home dial-status-home">
    <Layout
      type="HOME"
      pageTitle="软路由"
      titleSrc="/menu/dialStatus.png"
    >
      <!-- 设备总览 -->
      <BasiceLayout
        title="设备总览"
        class="bonus-code-layout revenue-all-layout "
      >
        <div class="BasicInput">
          <div class="revenueWrap top_total_revenue">
            <!-- 账号总数 -->
            <div class="one_day_revenue each_item_wrap ">
              <div class="revenue_item">
                <div class="revenue_title">节点总数</div>
              </div>
              <div
                class="revunue_value"
                v-if="total || total == 0"
              >{{total}} 台
              </div>
              <div
                class="revunue_value"
                v-if="!total && total !== 0"
              >-</div>
            </div>
            <!-- 拨号正常节点数量 -->
            <div class="one_day_invite_revenue each_item_wrap">
              <div class="revenue_item">
                <div class="revenue_title">拨号正常节点数量</div>
              </div>
              <div
                class="revunue_value"
                v-if="normal || normal == 0"
              >{{ normal  }} 台</div>
              <div
                class="revunue_value"
                v-if="!normal && normal !== 0"
              >-</div>
            </div>
            <!-- 拨号异常节点数量 -->
            <div class="total_revenue each_item_wrap">
              <div class="revenue_item">
                <div class="revenue_title">拨号异常节点数量</div>
              </div>
              <div
                class="revunue_value"
                v-if="error || error == 0"
              >{{ error }} 台
                <!-- <span
                  v-if="error"
                  class="bonus-cursor overview-show-detail"
                  @click="showDetail('error')"
                >查看详情</span> -->
              </div>
              <div
                class="revunue_value"
                v-if="!error && error !== 0"
              >- </div>
            </div>
          </div>
        </div>
      </BasiceLayout>
      <!-- 拨号状态 -->
      <BasiceLayout
        title="拨号状态"
        class="bonus-code-layout margin-top-20"
      >
        <div
          v-if="serverList && serverList.length && serverList !== 'NODATA'"
          v-for="item in serverList"
          class="item-list"
        >
          <div class="first-info">
            <div class="first-wrap">
              <div class="host-name margin-bottom-20">主机名：</div>
              <div class="host-info">{{item.serverHostname}}</div>
            </div>
            <div class="first-wrap margin-left-40">
              <div class="host-name margin-bottom-20">备注:</div>
              <div class="host-info">{{item.serverNote}}</div>
            </div>

          </div>
          <div class="second-info">
            <div>拨号账号总数：</span> {{item.all_count}}</div>
            <div>拨号正常数量：<span class="right-circle"></span>{{item.normal_count}}</div>
            <div>拨号异常数量：<span class="error-circle"></span>{{item.abnormal_count}}
              <span
                v-if="item.abnormal_count"
                class="bonus-cursor margin-left-20 bonus-color"
                @click="showAccounts(item)"
              >
                查看详情
              </span>
            </div>
          </div>

        </div>

        <div v-if="serverList === 'NODATA'" class="no-data margin-20 text-align-center">
          当前拨号均正常
        </div>

      </BasiceLayout>
    </Layout>
    <!-- 账号详情 -->
    <el-dialog
      title="异常账号"
      :visible.sync="showDialog"
      width="480px"
      center
    >
      <div class="">
        <div class="displax-flex">
          <div class="dial-left-wrap">
            账号
          </div>
          <div class="dial-right-wrap">
            密码
          </div>
        </div>
        <div v-for="item in accountList" class="displax-flex">
          <div class="dial-left-wrap">
            {{item.account}}
          </div>
          <div class="dial-right-wrap">
            {{item.pass}}
          </div>
        </div>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="showDialog = false"

        >{{ $t('sure') }}</div>
      </span>
    </el-dialog>
  </div>

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Layout from "@/components/DatePanel/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";

export default {
  name: "home",
  components: {
    Header,
    Layout,
    BasiceLayout
  },
  data() {
    return {
      accountList: [],
      showDialog: false
    };
  },
  computed: mapState({
    total: state => state.dialStatus.total,
    normal: state => state.dialStatus.normal,
    error: state => state.dialStatus.error,
    serverList: state => state.dialStatus.serverList
  }),
  created() {
    let date_at = moment()
      .utc()
      .startOf("minute")
      .subtract(3, "minute")
      .valueOf();

    this.getDialStatus({
      date_at,
        type: "error"

    });
  },
  methods: {
    ...mapActions(["getDialStatus"]),
    // showDetail() {
    //   this.getDialStatus({
    //     date_at: moment()
    //       .utc()
    //       .subtract(3, "minute")
    //       .valueOf(),
    //     type: "error"
    //   });
    // },
    showAccounts(item) {
      console.log(12);
      
      let list = [];
      for (var i in item.abnormal_list) {
        list.push({
          account: i,
          pass: item.abnormal_list[i]
        })
      }
      this.accountList = list;
      this.showDialog = true;
      
    }
  }
};
</script>

<style scoped lang="stylus">
.basic-layout-wrap {
  background: #fff;
  border: 1px solid #e3e3e7;
  position: relative;
}

.dial-status-home .item-list {
  border-bottom: 1px solid #ddd;
  margin: 20px;
}

.dial-status-home .second-info {
  display: flex;
  margin: 20px;

  // padding: 0 20px;
  div {
    width: 33.33%;
  }
}

.dial-status-home .first-info {
  display: flex;
  margin: 20px;

  .first-wrap {
    // margin: 20px;
    // padding: 0 20px;
  }
}

.dial-left-wrap, .dial-right-wrap {
  width:50%;
  text-align: center;
  margin-bottom: 20px;
}

.host-info {
  color: #65686a;
}

.right-circle{
  width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: #1add75;
    margin-right: 10px;
}
.error-circle{
  width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: red;
    margin-right: 10px;
}
</style>




